var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lz-tool",class:_vm.toolClasses},[_c('div',{staticClass:"lz-tool__icon"},[_vm._t("icon")],2),_c('div',{staticClass:"lz-tool__label"},[_vm._t("label")],2),_c('div',{staticClass:"lz-tool__check"},[_c('transition',{attrs:{"name":"fade"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }